/**
 * AdminShellLayout — DS Layout
 * Sidebar fixe + header + main — pattern admin Horaliia
 */

import styles from './AdminShellLayout.module.css';

interface AdminShellLayoutProps {
  header: React.ReactNode;
  sidebar: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  sidebarWidth?: string;
  className?: string;
}

export function AdminShellLayout({
  header,
  sidebar,
  children,
  footer,
  sidebarWidth = '220px',
  className = '',
}: AdminShellLayoutProps) {
  return (
    <div className={`${styles.root} ${className}`}>
      <header className={styles.header}>{header}</header>
      <div className={styles.body}>
        <aside className={styles.sidebar} style={{ width: sidebarWidth, minWidth: sidebarWidth }}>
          {sidebar}
        </aside>
        <main className={styles.main}>{children}</main>
      </div>
      {footer && <footer className={styles.footer}>{footer}</footer>}
    </div>
  );
}
